<template>
  <div>
    <el-dialog title="微信支付"
               :visible.sync="payVisible"
               size="tiny"
               ref="dialog"
               :modal="false"
               :modal-append-to-body="false">
      <span>请扫描下面二维码：</span>
      <!--<img :src="'http://www.qiyewan.com:8081/api/qrcode/wxpay?mhid=4xDADwDpnJ0hMHcvKtxTP6s&text=' + data"-->
           <!--width="260px"-->
           <!--height="260px">-->
      <img :src="qrCode"
           alt="支付二维码"
           width="260px"
           height="260px">
      <span slot="footer">
        <!--<el-button @click="isVisible = false">取 消</el-button>-->
<!--        <el-button type="primary" @click="back">返 回</el-button>-->
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import QrCode from 'qrcode'

  export default {
    data () {
      return {
        payVisible: false,
        data: '',
        imgBase64: '',
        qrCode: '',
      }
    },
    methods: {
      goBack() {
        this.payVisible = false
        console.log('asfda')
        console.log(this.payVisible)
        this.$emit('cancel')
      },
//      openDialog (data) {
//        this.data = data
//        this.$refs.dialog.open()
//      },
      openDialog (base64) {
        this.imgBase64 = base64
        let that = this
        try {
          // 生成二维码
          QrCode.toDataURL(base64).then(res => {
            that.qrCode = res
          })
        } catch (Ex) {
          console.error(Ex)
          this.$message.error('生成支付信息异常')
        }
        this.$refs.dialog.open()
      },
      handleDialogClose () {
        // this.$router.replace({name: 'order'})
      }
    }
  }
</script>



// WEBPACK FOOTER //
// WxPay.vue?221315d6